// extracted by mini-css-extract-plugin
export var externalLink = "_7j-0";
export var internalLinkLabel = "_7j-1";